import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { MultiContractData } from '@app/services/signal-r/model/multicontract-data';
import {
  addMultiContractData,
  addMultiContractDataBatch,
  purgeMultiContractDataByIds
} from '@app/store/faxe/multi-contract/multi-contract.actions';


export const identifier = (multiContractData: MultiContractData): string => multiConrtactKey(multiContractData);

export const multiConrtactKey = (model: MultiContractData): string =>
  `${model.multiContract.dataType}|${model.multiContract.version}`;

export const adapter: EntityAdapter<MultiContractData> = createEntityAdapter<MultiContractData>({
  selectId: identifier
});

export type MultiContractDataEntityState = EntityState<MultiContractData>;

export const initialState: MultiContractDataEntityState = adapter.getInitialState({
  // additional entity state properties
});

const reducer = createReducer(
  initialState,
  on(addMultiContractData, (state, { multiContractData, issuerStack }) => ({
    ...adapter.addOne(multiContractData, state)
  })),
  on(addMultiContractDataBatch, (state, { multiContractDataBatch, issuerStack }) => ({
    ...adapter.addMany(multiContractDataBatch, state)
  })),
  on(purgeMultiContractDataByIds, (state, { ids }) =>
    adapter.removeMany(ids, state)
  )
);

export const multiContractDataReducer: (state: (MultiContractDataEntityState | undefined), action: Action) =>
  EntityState<MultiContractData> = (state: MultiContractDataEntityState | undefined, action: Action) =>
  reducer(state, action);

// get the selectors
const {
  selectAll
} = adapter.getSelectors();

// select the array of users
export const selectAllMultiContractData = selectAll;


